import { Result } from "antd";
import React from "react";

const NotFound = () => <Result status="404" title="404" subTitle="Хуудас олдсонгүй" />;
export default NotFound
